
import React, { useEffect } from "react";

import s from "./Accordion.module.scss";

const Accordion = () => {

  useEffect(() => {

    const transitionDuration = .5;

    const initAccordion = (accordion) => {
      if (accordion) {
        const heads = accordion.querySelectorAll(`.${s.accordion__head}`);
        Array.prototype.forEach.call(heads, head => {
          head.addEventListener("click", onHeadClick);
        });
      }
    };

    const onHeadClick = (event) => {
      const accordionItem = event.currentTarget.parentElement;
      const accordionItemIsSelected = accordionItem.classList.contains(s.accordion__item____selected);
      const accordion = accordionItem.parentElement;

      if (!accordionItemIsSelected) {
        // if it's not a multi accordion stick to default behaviour (close other opened items)
        if (accordion.getAttribute("data-mode") !== "multi") {
          const selectedItem = accordion.querySelector(`.${s.accordion__item____selected}`);
          if (selectedItem) closeItem(selectedItem);
        }
        // open the item
        openItem(accordionItem);
      } else {
        // close current item (if it was opened)
        closeItem(accordionItem);
      }
    }

    const closeItem = (accordionItem) => {
      const accordionBody = accordionItem.querySelector(`.${s.accordion__body}`);
      // get the height
      const accordionBodyHeight = accordionBody.getBoundingClientRect().height;
      accordionItem.classList.remove(s.accordion__item____selected);
      // set inline height
      accordionBody.style.height = `${accordionBodyHeight}px`;
      // zero the height (animate)
      setTimeout(() => {
        accordionBody.style.height = 0;
        // remove inline height after the transition
        setTimeout(() => accordionBody.removeAttribute('style'), transitionDuration * 1000);
      }, 0);
    };

    const openItem = (accordionItem) => {
      accordionItem.classList.add(s.accordion__item____selected);
      // get the height (after opened)
      const accordionBody = accordionItem.querySelector(`.${s.accordion__body}`);
      const accordionBodyHeight = accordionBody.getBoundingClientRect().height;
      // immediately zero the height (don't open yet)
      accordionBody.style.height = 0;
      // set inline height to animate
      setTimeout(() => {
        accordionBody.style.height = `${accordionBodyHeight}px`;
        // remove inline height after the transition
        setTimeout(() => accordionBody.removeAttribute("style"), transitionDuration * 1000);
      }, 0);
    };

    // init all accordions
    const accordions = document.querySelectorAll(`.${s.accordion}`);
    Array.prototype.forEach.call(accordions, accordion => new initAccordion(accordion));

  }, []);

  const items = [
    {
      head1: "Regular accordion",
      head2: "Multi accordion",
      body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam vitae fermentum quam. Vestibulum lobortis vel nisl volutpat consectetur. Integer quis sem laoreet, consequat nunc nec, imperdiet mi. Pellentesque sit amet dictum lectus.",
    }, 
    {
      head1: "with a single item",
      head2: "allowing",
      body: "Sed malesuada nibh justo, ut feugiat turpis laoreet non. Nam eget gravida dui. Praesent congue nisl purus, porta elementum velit lobortis vitae. Donec augue tortor, lacinia eget diam vel, semper viverra libero.",
    }, 
    {
      head1: "being opened",
      head2: "all the items",
      body: "Donec id justo arcu. Donec convallis ultricies vestibulum. Maecenas sagittis, felis id rhoncus ullamcorper, massa mi molestie mauris, nec convallis urna quam in ligula. Pellentesque tristique sapien vitae enim rhoncus suscipit. Vestibulum eget sem accumsan, facilisis metus at, luctus nibh. Cras enim velit, scelerisque at dolor quis, eleifend interdum leo. Nunc id erat sit amet justo dictum convallis. Sed non tristique est. Sed pharetra vel nisl eget dapibus.",
    }, 
    {
      head1: "at a time.",
      head2: "being opened.",
      body: "Fusce quis leo et neque iaculis euismod vitae ut neque. Praesent aliquam enim nec accumsan vestibulum.",
    },
  ];

  const itemsMapped = (mode) => {
    return items.map((item, index) => (
      <li className={s.accordion__item} key={`item-${index}`}>
        <div className={s.accordion__head}>
          <h3>{mode === 1 ? item.head1 : item.head2}</h3>
          <span />
        </div>
        <div className={s.accordion__body}>
          <div>{item.body}</div>
        </div>
      </li>
    ));
  };

  return (
    <div className={s.container}>
      <ul className={s.accordion} data-mode="regular">
        {itemsMapped(1)}
      </ul>
      <ul className={s.accordion} data-mode="multi">
        {itemsMapped(2)}
      </ul>
    </div>
  );
};

export default Accordion;
